import * as React from 'react';
import {
  arrayOf as arrayOfType,
  bool as boolType,
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { useLocation } from '@thd-olt-component-react/router';
import { Col, Row, Heading } from '@thd-olt-component-react/core-ui';

export const ThankYou = () => {

  const location = useLocation();
  const URLParams = new URLSearchParams(location.search);
  const userEmailToken = URLParams.get('bv_authtoken') || '';

  const { data, loading, error } = useDataModel('reviewUserAuthentication', {
    variables: {
      bvAuthToken: userEmailToken
    },
    ssr: true
  });

  const success = data?.reviewUserAuthentication?.AuthorSubmissionToken
    || data?.reviewUserAuthentication?.SubmissionId || !data?.reviewUserAuthentication?.HasErrors;
  const hasUserAlreadyAuthenticated = data?.reviewUserAuthentication?.HasErrors
    && data?.reviewUserAuthentication?.Errors?.[0]?.Message === 'This user has already been authenticated.';

  const thankYou = hasUserAlreadyAuthenticated || success;

  return (
    <Row>
      <Row>
        <Col fallback={12}>
          <Heading underline>
            {!loading && (
              thankYou ? 'Thank you!' : 'Oops...'
            )}
          </Heading>
          {!loading && (
            thankYou ? 'Your email address has been authenticated.'
              : 'Our system is unable to verify your email address at this time. '
              + 'Try your confirmation link again later.'
          )}
        </Col>
      </Row>
    </Row>
  );
};

ThankYou.displayName = 'ThankYouPage';

ThankYou.dataModel = {
  reviewUserAuthentication: params({
    bvAuthToken: stringType().isRequired()
  }).shape({
    AuthorSubmissionToken: stringType(),
    Errors: arrayOfType(shape({
      Code: stringType(),
      Message: stringType()
    })),
    HasErrors: boolType(),
    SubmissionId: stringType()
  })
};
